import React from 'react';

/** @internal */
export var addEventIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "25",
  height: "25"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H25V13.75H13.75V25H0V0Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.6426 3.75V1.25H18.3926V6.365C17.6663 6.6225 17.1426 7.31 17.1426 8.125C17.1426 9.16125 17.9813 10 19.0176 10C20.0538 10 20.8926 9.16125 20.8926 8.125C20.8926 7.31 20.3688 6.6225 19.6426 6.365V5H23.3926V22.5H2.14258V5H4.91044V3.75H2.14258C1.45508 3.75 0.892578 4.3125 0.892578 5V22.5C0.892578 23.1875 1.45508 23.75 2.14258 23.75H23.3926C24.0801 23.75 24.6426 23.1875 24.6426 22.5V5C24.6426 4.3125 24.0801 3.75 23.3926 3.75H19.6426Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.51758 10C7.55383 10 8.39258 9.16125 8.39258 8.125C8.39258 7.31 7.86883 6.6225 7.14258 6.365V5H10.8926V3.75H7.14258V1.25H5.89258V6.365C5.16633 6.6225 4.64258 7.31 4.64258 8.125C4.64258 9.16125 5.48133 10 6.51758 10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.51758 10C7.55383 10 8.39258 9.16125 8.39258 8.125C8.39258 7.31 7.86883 6.6225 7.14258 6.365V5H10.8926V3.75H7.14258V1.25H5.89258V6.365C5.16633 6.6225 4.64258 7.31 4.64258 8.125C4.64258 9.16125 5.48133 10 6.51758 10"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7676 10C13.8038 10 14.6426 9.16125 14.6426 8.125C14.6426 7.31 14.1188 6.6225 13.3926 6.365V5H17.1426V3.75H13.3926V1.25H12.1426V6.365C11.4163 6.6225 10.8926 7.31 10.8926 8.125C10.8926 9.16125 11.7313 10 12.7676 10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7676 10C13.8038 10 14.6426 9.16125 14.6426 8.125C14.6426 7.31 14.1188 6.6225 13.3926 6.365V5H17.1426V3.75H13.3926V1.25H12.1426V6.365C11.4163 6.6225 10.8926 7.31 10.8926 8.125C10.8926 9.16125 11.7313 10 12.7676 10"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.625 16.875V24.375",
  className: "sicl-icon-stroke-color",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.875 20.625H24.375",
  className: "sicl-icon-stroke-color",
  strokeLinecap: "round"
}));